import { Route, Routes } from 'react-router-dom';
import EditWrapper from './EditWrapper';
import EditContent from './EditContent';
import { MediaRoutes } from '../../components/edit/media/MediaRoutes';
import { MediaCenter as MediaRoutesV2 } from './media';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../../flags';

const EditRoutes = () => {
  const { hasFeature } = useFeatureFlags();

  // Determine if the Media V2 feature flag is enabled for this user or globally
  const isMediaV2 = hasFeature(FeatureFlags.NGW_MEDIA_V2);

  const mediaElement = isMediaV2 ? <MediaRoutesV2 /> : <MediaRoutes />;

  return (
    <Routes>
      <Route element={<EditWrapper />}>
        <Route index element={<EditContent />} />
        <Route path="media/*" element={mediaElement} />
      </Route>
    </Routes>
  );
};

export default EditRoutes;
